import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {BreakpointObserver} from '@angular/cdk/layout';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BreakpointService {
  private breakpointObserver = inject(BreakpointObserver);

  private small = '(max-width: 1280px)';

  isSmallDevice$(): Observable<boolean> {
    return this.breakpointObserver
      .observe(this.small)
      .pipe(map(breakpointState => breakpointState.matches));
  }
}
